<script>
import PhoneField from '@phoenix/mixins/components/form/fields/PhoneField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [PhoneField],

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <text-field ref="fieldRef" v-model="value" :should-validate="false" :is-sgphx="isSgphx" />
</template>
